﻿import { UserDisplayName } from "@/components";
import { object, string } from "prop-types";
import { useState } from "react";
import { useIntl } from "react-intl";

const ApprovalStepDescription = ({ user, formattedDate }) => {
  const intl = useIntl();

  const { displayName, azureAdAccountEnabled: accountEnabled } = user;

  const [description] = useState(() => {
    if (!displayName) return;

    let description = (
      <UserDisplayName
        displayName={displayName}
        userAccountEnabled={accountEnabled}
        user={user}
      />
    );

    if (formattedDate) {
      description = (
        <>
          {description} {intl.formatMessage({ id: "general.on" })}{" "}
          {formattedDate}
        </>
      );
    }

    return description;
  });

  if (!description) return null;

  return <span className="whitespace-nowrap">{description}</span>;
};

ApprovalStepDescription.propTypes = {
  user: object.isRequired,
  formattedDate: string.isRequired,
};

export default ApprovalStepDescription;
